
import { ComputedRef, onBeforeMount, PropType, Ref, ref, watch } from "vue";
import { Interest, User } from "../../../../../domain/entities/entities";
import router from "../../../../../src/routes";
import Layout1 from "./steps/Layout1.vue";
import Layout2 from "./steps/Layout2.vue";
import Layout3 from "./steps/Layout3.vue";
import Layout4 from "./steps/Layout4.vue";
import Layout5 from "./steps/Layout5.vue";
import "./steps/steps.css";
import { dispatchErrorBox } from "../../mixins";
import { RepositoryException } from "../../../../../domain/exceptions/exceptions";
import { useStore } from "vuex";
import { computed } from "@vue/reactivity";
import Layout6 from "./steps/Layout6.vue";

export default {
  name: "Steps",
  components: { Layout6, Layout1, Layout2, Layout5, Layout4, Layout3 },

  props: {
    user: {
      type: Object as PropType<User>,
      required: true
    },

    messages: {
      required: true,
      type: Array
    },

    interests: {
      required: true,
      type: Array as PropType<Interest[]>
    },

    currentStep: {
      required: true,
      type: Number
    }
  },

  setup({ currentStep, user }, { emit }) {
    const store = useStore();
    const unifiedUser: Ref<User> = ref(user);
    const animationIsReverse = ref(false);
    let reDoOnBoarding = false;
    let lastStep = currentStep;

    const userInterest: ComputedRef<Interest[]> = computed(
      () => store.getters["interest_module/interests"]
    );

    onBeforeMount(async () => {
      reDoOnBoarding = await store.getters["userProfile_module/redoOnBoarding"];
      if (reDoOnBoarding) {
        await loadUser();
        await listUserInterest();
      }
    });

    const updateUser = event => {
      unifiedUser.value = { ...unifiedUser.value, ...event };
      emit("update:user", unifiedUser.value);
    };

    watch(
      () => router.currentRoute.value.params.step,
      () => {
        const newStep = Number(router.currentRoute.value.params.step);
        animationIsReverse.value = lastStep > newStep;
        lastStep = newStep;
      }
    );

    async function loadUser() {
      try {
        await store.dispatch("userProfile_module/loadUser");
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    async function listUserInterest(): Promise<void> {
      try {
        await store.dispatch("interest_module/listUserInterest");
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    return {
      animationIsReverse,
      unifiedUser,
      userInterest,
      updateUser
    };
  }
};
